export const BILLING_FILTERS = [
  { id: 'all', labelKey: 'billingFilterAll' },
  { id: 'attested', labelKey: 'billingFilterAttested' },
  { id: 'not_attested', labelKey: 'billingFilterNotAttested' },
  { id: 'invoiced', labelKey: 'billingFilterInvoiced' },
  { id: 'not_invoiced', labelKey: 'billingFilterNotInvoiced' }
];

export function matchesBillingFilter(task, filterId) {
  if (filterId === 'attested') {
    return Boolean(task.attested);
  }
  if (filterId === 'not_attested') {
    return !task.attested;
  }
  if (filterId === 'invoiced') {
    return Boolean(task.invoiced);
  }
  if (filterId === 'not_invoiced') {
    return !task.invoiced;
  }
  return true;
}

export function isPendingBilling(task) {
  return task?.status === 'completed' && (!task.attested || !task.invoiced);
}

export function mergeTaskBilling(task, billing) {
  if (!task || !billing) {
    return task;
  }
  return {
    ...task,
    attested: billing.attested,
    attested_by: billing.attested_by,
    attested_at: billing.attested_at,
    attested_by_name: billing.attested_by_name,
    invoiced: billing.invoiced,
    invoiced_by: billing.invoiced_by,
    invoiced_at: billing.invoiced_at,
    invoiced_by_name: billing.invoiced_by_name
  };
}

/** Group selected tasks by location for Fortnox-oriented JSON export. */
export function buildFortnoxSelectionExport(tasks) {
  const byLocation = new Map();

  tasks.forEach((task) => {
    const locationId = task.location_id || null;
    const key = locationId == null ? 'none' : String(locationId);
    if (!byLocation.has(key)) {
      byLocation.set(key, {
        locationId,
        locationName: task.location_name || task.location || null,
        taskIds: [],
        tasks: []
      });
    }
    const group = byLocation.get(key);
    group.taskIds.push(task.id);
    group.tasks.push({
      id: task.id,
      title: task.title,
      status: task.status,
      attested: Boolean(task.attested),
      invoiced: Boolean(task.invoiced),
      attested_at: task.attested_at || null,
      invoiced_at: task.invoiced_at || null,
      scheduled_for: task.scheduled_for || null,
      updated_at: task.updated_at || null,
      assigned_user_names: task.assigned_user_names || null
    });
  });

  return {
    format: 'serviceinmind-fortnox-invoice-selection',
    exportedAt: new Date().toISOString(),
    groups: [...byLocation.values()]
  };
}
